export enum S3ACL {
    Public = "public-read",
    Private = "private"
}